import { IsNotEmpty, IsOptional, IsString } from "class-validator";

import { IBreedGroupJudge } from "./breed-group-judge.interface";

export class BreedGroupJudgeDto implements IBreedGroupJudge {
  @IsNotEmpty()
  breed_group: string;

  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  judge_number?: string;

  @IsOptional()
  @IsString()
  start_letter?: string;

  @IsOptional()
  @IsString()
  end_letter?: string;
}
